import React, { useMemo, useState } from 'react';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import { DetailsCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CommonCloums';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import { LANGUAGE_CN } from '@intelligence/_config/config';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import { Table, Rate } from 'tea-component';
import type { TableColumn } from 'tea-component';
import { dataSource } from '../../_config';
import { DataSourceType } from '../../types';
import { useIntl, history, getLocale } from 'umi';

const CreditabilityTable = () => {
  const [sortType, setSortType] = useState<'desc' | 'asc'>('desc');
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const onSortChange = (value: SortByItemType) => {
    setSortType(value?.sortVal || 'desc');
  };

  const columns: TableColumn<DataSourceType>[] = [
    {
      key: 'source',
      width: 120,
      header: formatMessage({ id: 'dbi_top_sources' }),
      render: (cvm) => {
        return (
          <div className="dbi-metrics-creditability-table-source">
            {cvm?.icon ? (
              <img
                className="table-source-image"
                src={getDataSourceIcon(cvm?.icon)}
                alt=""
                width={18}
                height={18}
              />
            ) : null}
            <span>{cvm?.source}</span>
          </div>
        );
      },
    },
    {
      key: 'creditability',
      width: 120,
      header: formatMessage({ id: 'dbi_creditability_header' }),
      // header: () => (
      //   <CloumsCenter align="left" width={150}>
      //     <SortBy
      //       align="left"
      //       title={formatMessage({ id: 'dbi_creditability_header' })}
      //       list={[
      //         {
      //           key: 'creditability',
      //           sortMetric: 'creditability',
      //           text: formatMessage({ id: 'dbi_creditability_header' }),
      //           title: formatMessage({ id: 'dbi_creditability_header' }),
      //         },
      //       ]}
      //       defaultKey="creditability"
      //       defaultValue={'desc'}
      //       onChange={onSortChange}
      //     />
      //   </CloumsCenter>
      // ),
      render: (cvm) => {
        return <Rate readonly value={cvm?.credibility} allowHalf theme="primary" />;
      },
    },
    {
      key: 'metrics',
      width: 150,
      header: formatMessage({ id: 'dbi_label_metrics' }),
      render: (cvm) => {
        const targetMetric = cvm?.combineMetrics || cvm?.metrics || [];
        const metric = targetMetric?.join(',');
        return (
          <div
            className="dbi-metrics-creditability-table-metrics"
            onClick={() =>
              history.push(
                `${cvm?.url}?metric=${metric}&pageid=${
                  cvm?.icon || cvm?.source?.toLocaleLowerCase()
                }`,
              )
            }
          >
            {cvm?.metrics?.join('/')}
          </div>
        );
      },
    },
    {
      key: 'info',
      width: 360,
      header: formatMessage({ id: 'dbi_creditability_info' }),
      render: (cvm) => {
        const infoList = cvm?.info || [];
        return infoList?.map((item, index) => (
          <div key={index}>{locale === LANGUAGE_CN ? item?.title_zh : item?.title_en}</div>
        ));
      },
    },
    DetailsCloums({
      onClickGame: (cvm: DataSourceType) => {
        const targetMetric = cvm?.combineMetrics || cvm?.metrics || [];
        const metric = targetMetric?.join(',');
        history.push(`${cvm?.url}?metric=${metric}&pageid=${cvm?.icon || 'gsd'}`);
      },
      formatMessage,
    }),
  ];

  // const tableData = useMemo(() => {
  //   return dataSource?.sort((a, b) =>
  //     sortType === 'desc'
  //       ? b.credibility - a.credibility
  //       : a.credibility - b.credibility,
  //   );
  // }, [sortType]);
  return (
    <CardSlot>
      <Table recordKey="id" columns={columns} records={dataSource} />
    </CardSlot>
  );
};

export default CreditabilityTable;
